import type { IContacts } from '@modules/payment-system-details/types';

export interface IContactsMenuButtonProps {
  translateKey: symbol;
  buttonTitle?: string;
  contacts?: IContacts;
  disabled?: boolean;
}

export enum IContactsTypes {
  WHATSAPP = 'whatsapp',
  TELEGRAM = 'telegram',
  EMAIL = 'email',
  MS_TEAMS = 'ms_teams',
}

export interface IContactsMenuOption {
  type: IContactsTypes;
  label: string;
  value?: string;
  icon?: string;
}
